export default function timeRange(from_, to, delta) {
  const result = []
  const now = from_.clone()
  while (now.isBefore(to)) {
    result.push(now.clone())
    now.add(delta)
  }
  return result
}
